import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast } from 'antd-mobile';
import Http from '../../config/axiosUtils';

import '../../assets/scss/Custom/customDetail.scss';

class CustomDetail extends Component {
  state = {
    initData: {
      customerNodeList: []
    },
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const path = `/spread/web/customer/detail/${this.props.match.params.id}`;
    const res = await Http.post(path);
    if (res.code === 0) {
      this.setState({
        initData: res.data,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  render () {
    const { initData } = this.state;
    return (
      <div>
        <Helmet><title>客户详情</title></Helmet>
        <div className='customDetail'>
          <div className='title'>
            <div>{initData.name}</div>
            <div>{initData.mobile}</div>
          </div>
          <ul>
            {
              initData.customerNodeList.map((item, index) => {
                return (
                  <li key={index}>
                    <span>{item.nodeName}</span>
                    <span className='tag'>{item.customerTag}</span>
                    <span>{item.nodeTime}</span>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    )
  }
}

export default CustomDetail;